import $ from 'jquery'
import lottie from 'lottie-web'
import 'waypoints/lib/jquery.waypoints.min.js'

$(document).ready(function () {
  $('.js-icon-block-mobile-handle').on('click', function () {
    $(this)
      .closest('.icon-block')
      .toggleClass('mobile-active')
      .find('.js-icon-block-mobile-container')
      .stop()
      .slideToggle()
  })
})

var iconAnimations = []
var divContainers = document.getElementsByClassName('js-animated-icon')

Array.from(divContainers).forEach(el => {
  var params = {
    container: el,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    animationData: require(`./animations/${el.dataset.animation}`),
  }

  iconAnimations.push(lottie.loadAnimation(params))
})

$(window).load(function () {
  iconAnimations.forEach(function (animation) {
    animation.setSpeed(1.5)
    $(animation.wrapper).waypoint({
      handler: direction => {
        if (direction == 'down') {
          animation.play()
        }
      },
      offset: 'bottom-in-view',
    })
  })
})
